module.exports = __webpack_public_path__ + "img/zhengceicon.802f4d02.jpeg";